<template>
    <div class="modal-card" style="width: auto">
      <header class="modal-card-head">
         <p class="modal-card-title">Session Expiration</p>
      </header>
      <section class="modal-card-body">
        <p>Your session is going to expire in {{ this.timeUntilSessionExpiration }}</p>
        <br>
        <p>Would you like to continue your session?</p>
      </section>
      <footer class="modal-card-foot" style="justify-content: flex-end">
        <b-button type="is-primary" @click="continueSession()" :loading="isRefreshingAuthentication" :disabled="! isContinueSubmittable">Continue</b-button>
      </footer>
    </div>
</template>

<script>
import store from '@/store'
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'

import SessionExpiringModal from '@/components/SessionExpiringModal'

export default {
  props: {
    now: {
      required: true
    },
    expiration: {
      required: true
    }
  },
  computed: {
    ...mapGetters([
      'expires'
    ]),
    isRefreshingAuthentication () {
      return this.$wait.is(['refreshing authentication'])
    }, 
    isContinueSubmittable () {
      return ! this.isRefreshingAuthentication
    }, 
    timeUntilSessionExpiration () {
      return moment.utc(moment.duration(this.expiration.diff(this.now, 'seconds'), 'seconds').asMilliseconds()).format('mm:ss')
    }
  },
  methods: {
    ...mapActions([
      'refreshAuthentication'
    ]),
    continueSession () {
      try {
        this.refreshAuthentication()
        this.$parent.close()
      } catch (error) {
        switch (error.response.status) {
          case 422:
            this.apiValidationErrors = error.response.data.errors
            this.isValid(autoSave)
            break
          default:
            console.log(error)
        }
        return Promise.reject(error)
      }
    }
  }
}
</script>

